import { DayOfWeek } from "../../types";

export const DAY_LABELS: Record<DayOfWeek, string> = {
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
};

// soft colour per subject, so the week reads at a glance (same subject = same colour everywhere)
const SUBJECT_COLORS = ["#2563eb", "#059669", "#d97706", "#7c3aed", "#db2777", "#0891b2", "#65a30d", "#dc2626", "#4f46e5", "#0d9488"];
export const colorOf = (subjectCode: string) => {
  let hash = 0;
  for (const ch of subjectCode) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return SUBJECT_COLORS[hash % SUBJECT_COLORS.length];
};

/** Today as a DayOfWeek, or null on Sunday. */
export const todayDay = (): DayOfWeek | null =>
  (["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"][new Date().getDay()] as DayOfWeek) ?? null;
